import React from 'react';

import { Flex } from '@chakra-ui/react';

import { TagColored } from 'uiToolkitV1/Tag';
import { TextBodyMedium } from 'uiToolkitV1/Typography';

const STATUS_INFO = {
  PROMOTE: {
    color: 'green',
    text: 'Promote',
  },
  NO_CHANGE: {
    color: 'yellow',
    text: 'No Change',
  },
  PIP: {
    color: 'red',
    text: 'PIP',
  },
  FUTURE_PROMOTE: {
    color: 'blue',
    text: 'Future Consideration',
  },
};

const getStatusInfo = (status) => STATUS_INFO[status] || null;

const PromoStatusV1 = ({ status }) => (
  <Flex alignItems="center">
    {status ? (
      <TagColored color={getStatusInfo(status)?.color}>{getStatusInfo(status)?.text}</TagColored>
    ) : (
      <TextBodyMedium>NA</TextBodyMedium>
    )}
  </Flex>
);

export default PromoStatusV1;
